<template>
  
    
      <div class="listItems d-flex align-items-center justify-content-between pdl-16 pdr-16"> 

        <div v-if="leaderList.rank=='1'"
          class="slIcon pdl-6 font-rm d-flex align-items-center justify-content-center t-color-textField2 t-headline12"
        >
          <img src="images/leader/medal1.png" alt />
        </div>
        <div v-else-if="leaderList.rank=='2'"
          class="slIcon pdl-6 font-rm d-flex align-items-center justify-content-center t-color-textField2 t-headline12"
        >
          <img src="images/leader/medal2.png" alt />
        </div>
        <div v-else-if="leaderList.rank=='3'"
          class="slIcon pdl-6 font-rm d-flex align-items-center justify-content-center t-color-textField2 t-headline12"
        >
          <img src="images/leader/medal3.png" alt />
        </div>
        <div v-else
          class="slIcon pdl-6 font-rm d-flex align-items-center justify-content-center t-color-textField2 t-headline7"
        >{{ leaderList.rank }}</div>


        <div v-if="leaderList.profile"
          class="userListIcon font-rm d-flex justify-content-center align-items-center t-color-white mgl-22 t-headline7"
        ><img :src="leaderList.profile" alt="" class="w-40 h-40"  /></div>
        <div v-else
          class="userListIcon font-rm pdl-2  d-flex justify-content-center align-items-center t-color-white mgl-22 t-headline7"
        ><img src="images/avatar_image.png" alt="" /></div>

        <div class="listContent mgl-16">
          <p class="t-body1 l-spacing48 t-color-title mgb-6 mgt-22">{{ leaderList.name }}</p>
          <p class="t-body2 mgt-1 t-color-textField1 mgb-19" style="text-transform: uppercase;">
            {{$t('786')}} 
            {{ leaderList.levelName }}</p>
        </div>

        <div class="listPointsWrapper d-flex align-items-center">
          <span
            class="listPointIcon d-flex justify-content-center align-items-center t-color-white bg-textField2 mgr-4 pdt-2 t-body4"
          >P</span>
          <span class="t-subtitle2 font-rb">{{ leaderList.point | commafy }}</span>
        </div>
      </div>
    
</template>

<script>
/**
 * 나의 학습 목록 아이템 컴포넌트(my learning main list item component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCRipple } from "@material/ripple";
import learnApi from "@/api/learnApi.js";

export default {
  name:'ListItem',
  props: ["leaderList"],
  data() {
    return {
      learnProgressRate: {},
    };
  },
  filters: {
    commafy: function (value) {
      if (!value) return ''

      var str = value.toString();
      str = str.replace(/(\d)(?=(\d{3})+$)/g, '$1,');
      return str;
    }
  },
  mounted() {},

  computed: {},
  methods: {
    // 학습진행율 데이터 (get learning status data)
  },
};
</script>

<style scoped>
.bg-red3 {
  background: #2d6dcc;
}
.t-color-textField2 {
  color: #acb4be;
}
.t-color-textField1 {
  color: #546e7a;
}
.bg-textField2 {
  background-color: #acb4be;
}
.nav-extended .brand-logo,
.nav-content * {
  font-family: noto-regular;
}
.nav-extended .brand-logo {
  font-size: 20px;
}
.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: #f5f5f5;
  outline: none;
}
.tabs .indicator {
  background: #2d6dcc;
}
.tabs .tab {
  width: 50%;
}
.mdc-elevation--z3 {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  background-color: #ffffff;
}
.header-card {
  height: 120px !important;
}
.listItems {
  border-bottom: 1px solid #e6eced;
}

.rank {
  min-width: 82px;
}
.ranktab2 {
  min-width: 46px;
}

.level-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  font-size: 28px;
  overflow: hidden;
}

.slIcon {
  width: 35px;
}
.slIcon img {
  width: 27px;
}
.userListIcon {
  width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
}
.userListIcon img {
  width: 40px;
}

.listContent p:first-child {
  font-size: 16px;
}
.listPointIcon {
  width: 19px;
  min-width: 19px;
  height: 19px;

  border-radius: 50%;
}
.levelHeading .listPointIcon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-weight: 500;
}

.listContent{
   width: 35%;
   margin-right: auto;
}
/* 1sept20 start */
/* .slIcon img[data-v-0dc649d7]{width: 20px;}
.userListIcon[data-v-0dc649d7] {
    width: 32px;
    min-width: 32px;
    height: 32px;}
  .userListIcon img[data-v-0dc649d7]{width:32px !important;height:32px !important;}
  .listContent p[data-v-0dc649d7]:first-child, .t-color-textField1[data-v-0dc649d7]{font-size: 14px;}
  .t-subtitle2 {font-size: .75rem;}
  .listPointIcon[data-v-0dc649d7] {
    width: 16px;
    min-width: 16px;
    height: 16px;} */
/* 1sept20 end */
@media (max-width: 480px) {
  .listContent {
    margin-right: auto;
  }
}
</style>